import * as React from 'react';

import classNames from 'classnames';

import Imgix from 'js/components/Imgix';

import DefaultOrganizationLogo from 'bundles/enterprise-legacy-learner-home/components/DefaultOrganizationLogo';
import DefaultUserLogo from 'bundles/enterprise-legacy-learner-home/components/DefaultUserLogo';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/enterprise-admin-home';

import 'css!./__styles__/ContextButton';

export type ContextProps = {
  key: string;
  href: string;
  header: string;
  label?: string;
  showLabel?: boolean;
  photoUrl?: string;
  rootClassName?: string;
  primaryColor?: string;
  iconColor?: string;
  // below props injected by withKeyboardControls HOC in ./AdminNavigationDropdown.jsx
  tabIndex?: number;
  onKeyDown?: () => void;
  targetRef?: () => void;
};

const ContextButton = ({
  key,
  href,
  header,
  label,
  showLabel,
  photoUrl,
  primaryColor,
  iconColor,
  rootClassName,
  tabIndex,
  onKeyDown,
  targetRef,
}: ContextProps) => (
  <li key={key} className={classNames('rc-ContextButton', rootClassName)}>
    <TrackedA
      aria-label={label}
      href={href}
      id={`${header}-link`}
      role="menuitem"
      trackingName="header_right_nav_button"
      data={{ label }}
      tabIndex={tabIndex || 0}
      onKeyDown={onKeyDown}
      refAlt={targetRef}
    >
      <div className="photo-container">
        {photoUrl && <Imgix alt={_t('Organization logo')} src={photoUrl} maxWidth={32} maxHeight={32} />}
        {!photoUrl && href !== '/?skipBrowseRedirect=true' && (
          <DefaultOrganizationLogo size={32} thirdPartyOrganization={{ name: label, primaryColor, iconColor }} />
        )}
        {!photoUrl && href === '/?skipBrowseRedirect=true' && <DefaultUserLogo size={32} />}
      </div>
      {showLabel && (
        <div className="text-container">
          <div>{header}</div>
          <div className="organization-name">{label}</div>
        </div>
      )}
      {!showLabel && <div>{header}</div>}
    </TrackedA>
  </li>
);

export default ContextButton;
